import styled from "styled-components/macro";

export const NewHomepageContainer = styled.div`
  background-color: #f5f2e4;
  overflow-x: hidden;
  nav {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    #logo {
      padding: 24px;
      width: 80px;
      opacity: 0.5;
    }
    .login {
      font-family: "Inter";
      font-weight: 500;
      padding: 24px;
      padding-right: 36px;
      a {
        color: #2b2315;
        opacity: 0.5;
      }
    }
  }
  h1 {
    font-family: "GT Super Text";
    font-weight: 600;
    font-size: 54px;
    margin: 0;
  }
  h2 {
    font-size: 42px;
    font-family: "GT Super Text";
    font-weight: 600;
    line-height: 110%;
  }
  h3 {
    font-family: "GT Super Text";
    font-weight: 600;
    font-size: 24px;
    line-height: 130%;
  }
  a {
    color: inherit;
  }
  button {
    border-radius: 10px;
    font-size: 18px;
    padding: 16px 24px;
    outline: 0;
    border: 0;
    text-decoration: none;
    cursor: pointer;
    font-family: "Inter";
    font-weight: 400;
    transition: font-size 200ms;
  }
  section {
    display: flex;
    flex-direction: column;
  }

  .blur {
    position: absolute;
    width: 1000px;
    max-width: 70vw;
    z-index: 0;
    left: 0px;
  }

  .content-row {
    display: flex;
    flex-direction: row;
    max-width: 1100px;
    margin: auto;
    align-items: center;
    h2 {
      max-width: 600px;
      text-align: left;
    }
    transition: max-width 200ms;
  }

  #hero-module {
    .blur {
      top: -50px;
    }
    #hero {
      z-index: 1;
      width: 50vw;
      transition: width 200ms;
    }
  }

  #product-module {
    #brainstorm,
    #feedback,
    #rewrite {
      width: 45vw;
      max-width: 600px;
    }
    .content-row {
      justify-content: space-between;
      width: 90vw;
      .feature-copy {
        max-width: 370px;
      }
      #brainstorm-buddy {
        max-width: 460px;
      }
    }
  }

  #testimonials-module {
    .quote {
      transition: margin-bottom 200ms;
      font-family: "GT Super Text";
      font-weight: 300;
      font-style: italic;
      line-height: 130%;
      max-width: 448px;
      font-size: 28px;
      text-align: left;
      background-color: #fff;
      padding: 24px;
      border-radius: 24px;
      position: absolute;
      .caption-column {
        display: flex;
        flex-direction: column;
        position: absolute;
        p {
          font-style: normal;
        }
        img {
          width: 200px;
        }
        .caption {
          font-family: "GT Super Text";
          opacity: 0.5;
          font-size: 18px;
        }
      }
    }
    .quote-mini {
      font-family: "GT Super Text";
      font-weight: 300;
      font-style: italic;
      max-width: 150px;
      font-size: 18px;
      text-align: left;
      background-color: #fff;
      padding: 14px;
      border-radius: 12px;
      position: absolute;
    }
    .speech-bubble-point {
      position: absolute;
      bottom: -36px;
    }
    .quote-canvas {
      width: 100vw;
      max-width: 1000px;
      height: 650px;
      position: relative;
      margin: auto;

      #nyt-quote {
        width: 418px;
        left: 15%;
      }
      #nyt-caption {
        bottom: -80px;
        left: 22%;
      }
      #nyt-bubble-point {
        left: 28px;
      }
      #washpo-quote {
        width: 412px;
        right: 2.5%;
        top: 35%;
      }
      #washpo-caption {
        left: 5%;
        bottom: -80px;
      }
      #washpo-bubble-point {
        left: 244px;
        -webkit-transform: scaleX(-1);
        transform: scaleX(-1);
      }
      #new-yorker-quote {
        width: 390px;
        bottom: 15%;
        left: 2.5%;
      }
      #new-yorker-caption {
        bottom: -80px;
        left: 27%;
      }
      #new-yorker-bubble-point {
        left: 42px;
      }
    }
    .quote-canvas-authors {
      width: 100vw;
      max-width: 1120px;
      height: 300px;
      position: relative;
      text-align: center;

      .content-column {
        align-items: center;
        position: relative;
        width: 190px;
        .author-name {
          font-family: "Inter";
          font-weight: 600;
          line-height: 160%;
          font-size: 20px;
          font-family: "GT Super Text";
        }
        .author-bio {
          font-family: "Inter";
          opacity: 0.55;
          line-height: 130%;
          font-weight: 500;
          font-family: "GT Super Text";
        }
        .portrait {
          height: 160px;
          border-radius: 16px;
        }
      }

      #John-quote {
        bottom: 200px;
        left: -130px;
      }
      #John-bubble-point {
        width: 50px;
        left: 124px;
      }
      #Hugh-quote {
        bottom: 244px;
        left: -20px;
      }
      #Hugh-bubble-point {
        left: 22px;
        bottom: -43px;
      }
      #Mark-quote {
        bottom: 175px;
        left: 150px;
        width: 99px;
      }
      #Mark-bubble-point {
        left: 0px;
        -webkit-transform: scaleX(-1);
        transform: scaleX(-1);
      }
      .content-row {
        position: absolute;
        left: 50%;
        bottom: 0%;
        transform: translateX(-50%);
      }
    }
    #author-header {
      max-width: 90vw;
      width: 380px;
    }
  }

  #cta-module {
    #hero-2 {
      width: 50vw;
      z-index: 1;
    }
    #cta-button-lockup {
      margin: 0;
    }
    .content-row {
      justify-content: space-between;
    }
    .content-column {
      z-index: 10;
      .trial-copy {
        width: 45vw;
        max-width: 500px;
      }
      .disclaimer {
        font-family: "Inter";
        max-width: 260px;
        text-align: left;
        opacity: 0.5;
        line-height: 120%;
      }
    }
  }

  #manifesto-module {
    z-index: 10;
    a {
      text-decoration: underline;
      text-decoration-thickness: from-font;
      text-underline-offset: 0.5px;
    }
    .manifesto-header {
      width: 27vw;
      max-width: 300px;
      text-align: right;
    }
    .content-row {
      align-items: baseline;
      #origin-story {
        font-family: "GT Super Text";
        font-weight: 300;
        line-height: 130%;
        width: 57%;
        max-width: 500px;
        text-align: left;
        font-size: 20px;
      }
    }
  }

  #footer-module {
    .content-row {
      align-items: flex-start;
      .footer-header {
        font-family: "Inter";
        line-height: 130%;
        font-weight: 600;
        width: 115px;
        text-align: left;
      }
      .footer-item {
        cursor: pointer;
        font-family: "Inter";
        line-height: 130%;
        font-weight: 500;
        opacity: 0.5;
      }
    }
  }

  .wide {
    max-width: 100%;
    margin: 0;
    justify-content: space-between;
  }

  .use-space-between {
    justify-content: space-between;
  }

  .content-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    max-width: 600px;
  }

  .light {
    position: relative;
    background-color: #f5f2e4;
    color: #2b2315;
  }
  .dark {
    position: relative;
    background-color: #2b2315;
    color: #f5f2e4;
    z-index: 1;
    button {
      font-weight: 500;
    }
    .logo {
      opacity: 1;
    }
  }
  .yellow {
    background-color: #ffeeb1;
    color: #261b04;
  }
  .spacer-lg {
    height: 100px;
    width: 100px;
    display: block;
  }
  .spacer {
    height: 75px;
    width: 75px;
    display: block;
  }
  .spacer-medium {
    height: 50px;
    width: 50px;
    display: block;
  }
  .spacer-small {
    height: 32px;
    width: 32px;
  }
  .spacer-smaller {
    height: 20px;
    width: 20px;
  }
  .spacer-smallest {
    height: 8px;
    width: 8px;
  }

  @media (max-width: 1200px) {
    button {
      border-radius: 8px;
      font-size: 18px;
      padding: 12px 18px;
    }
    #blur,
    #blur-2 {
      width: 70vw;
    }
    h1 {
      font-size: 4vw;
      width: 40vw;
    }
    h2 {
      font-size: 4vw;
      width: 40vw;
    }
    #testimonials-module {
      h2 {
        width: auto;
      }
    }
  }

  @media (max-width: 960px) {
    //tablet
    #product-module {
      img,
      h1,
      h2,
      h3 {
        max-width: 45vw;
      }
      .content-row {
        max-width: 90vw;
        margin: auto;
      }
    }

    #testimonials-module {
      h2 {
        width: auto;
      }
      .content-row {
        flex-direction: column;
        width: 90vw;
      }
      #newspaper-quotes {
        margin: 0;
      }
      #author-header {
        max-width: 90vw;
        width: 380px;
      }
      .quote-canvas {
        width: 100vw;
        display: flex;
        flex-direction: column;
        height: auto;
        align-items: center;
        margin: 0;
        #nyt-quote,
        #washpo-quote,
        #new-yorker-quote {
          width: 80vw;
          left: 5vw;
        }

        #nyt-caption,
        #washpo-caption,
        #new-yorker-caption {
          left: 20px;
          align-items: flex-start;
        }
        #washpo-caption {
          right: 10px;
          left: auto;
        }

        #washpo-bubble-point {
          left: 30px;
          transform: scaleX(1);
        }
        #nyt-bubble-point,
        #new-yorker-bubble-point {
          right: 50px;
          left: auto;
          transform: scaleX(-1);
        }
      }
      .quote-canvas-authors {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        height: auto;
        .content-row {
          position: relative;
          width: 100%;
        }
        #John-quote {
          bottom: 197px;
          left: -82px;
          width: 119px;
        }
        #John-bubble-point {
          left: 102px;
          top: 63px;
        }
        #Hugh-quote {
          bottom: 242px;
          left: 117px;
          width: 124px;
        }
        #Hugh-bubble-point {
          transform: scaleX(-1);
          left: 42px;
        }
        #Mark-quote {
          bottom: 180px;
          left: -78px;
          width: 106px;
        }
        #Mark-bubble-point {
          left: 65px;
          transform: scaleX(1);
        }
      }
      .quote {
        position: relative;
        max-width: 400px;
        margin-bottom: 100px;
      }
      .caption-column {
        position: absolute;
        align-items: flex-start;
        max-width: 300px;
        p {
          text-align: left;
        }
      }
      .quote-canvas-authors {
        width: 100vw;
        display: flex;
        flex-direction: column;
      }
    }
    #cta-module {
      .content-column {
        position: relative;
        .content-row {
          flex-direction: column;
          align-items: flex-start;
        }
      }
    }
    #manifesto-module {
      .content-row {
        flex-direction: column;
        width: 75vw;
        h3 {
          width: 40vw;
        }
        #origin-story {
          width: 90vw;
          max-width: 100%;
        }
        .manifesto-header {
          text-align: left;
          width: 90vw;
        }
      }
    }
    .hide-on-tablet {
      display: none;
    }
  }

  @media (max-width: 760px) {
    button {
      border-radius: 6px;
      font-size: 14px;
      padding: 10px 14px;
    }
  }

  @media (max-width: 700px) {
    //mobile-lg
    #legal,
    #product {
      display: none;
    }

    .hide-on-mobile-lg {
      display: none;
    }
  }

  @media (max-width: 500px) {
    //mobile
    #hero-module {
      #hero {
        width: 100vw;
      }
      .blur {
        z-index: 1;
        top: -12vw;
        width: 130vw;
        max-width: 130vw;
      }
      .content-column {
        z-index: 10;
      }
    }
    #cta-module {
      #hero-2 {
        width: 100vw;
      }
      .blur {
        z-index: 1;
        top: 9vw;
        width: 130vw;
        max-width: 130vw;
      }
    }
    nav {
      .login {
        padding-right: 24px;
      }
    }

    h1 {
      font-size: 35px;
      width: 90vw;
    }
    h2 {
      font-size: 35px;
      width: 90vw;
    }

    button {
      border-radius: 6px;
      font-size: 20px;
      padding: 14px 24px;
    }

    .wide {
      max-width: 90%;
      margin: auto;
    }

    .hide-on-mobile {
      display: none;
    }
    .hide-on-desktop {
      display: block;
    }

    .smaller-on-mobile {
      width: 25px;
      height: 25px;
    }

    .medium-on-mobile {
      width: 50px;
      height: 50px;
    }

    #product-module {
      h2 {
        max-width: 90vw;
      }
      #feedback,
      #brainstorm,
      #rewrite {
        width: 90vw;
        max-width: 90vw;
      }
    }

    .content-row {
      flex-direction: column;
      #brainstorm-buddy {
        max-width: 310px;
      }
    }

    #testimonials-module {
      #newspaper-quotes {
        margin: 0;
      }
      .content-row {
        margin: auto;
      }
      h2 {
        text-align: center;
        margin: auto;
      }
    }

    #cta-module {
      .content-column {
        align-items: flex-start;
      }
      .content-row {
        .trial-copy {
          width: 90vw;
        }
      }
      #cta-button-lockup {
        align-items: flex-start;
      }
    }

    .reverse-order-on-mobile {
      flex-direction: column-reverse;
    }

    #manifesto-module {
      .content-row {
        width: 90vw;
      }
    }

    #footer-module {
      #sitemap {
        flex-direction: row;
        flex-wrap: wrap;
        padding-left: 0;
        #product {
          padding-bottom: 24px;
        }
      }
    }
  }
`;
